import { render } from "./registerRoom.vue?vue&type=template&id=310c9f01&scoped=true"
import script from "./registerRoom.vue?vue&type=script&lang=js"
export * from "./registerRoom.vue?vue&type=script&lang=js"

import "./registerRoom.vue?vue&type=style&index=0&id=310c9f01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310c9f01"]])

export default __exports__